/* Wallspoke header: desktop panels, mobile drawer, occasion row on scroll,
   cart count. Markup in sections/header.liquid. No dependencies. */
(function () {
  var DESKTOP = window.matchMedia('(min-width: 990px)');
  var HOVER_CLOSE_MS = 120;
  var current = null; // teardown for the live instance

  function init(root) {
    if (!root || root.dataset.wshInit) return;
    root.dataset.wshInit = '1';
    if (current) current();

    var html = document.documentElement;
    var bar = root.querySelector('[data-wsh-bar]');
    var cleanups = [];
    function on(target, type, fn, opts) {
      target.addEventListener(type, fn, opts);
      cleanups.push(function () { target.removeEventListener(type, fn, opts); });
    }

    /* ---------- Desktop panels ---------- */
    var triggers = [].slice.call(root.querySelectorAll('[data-wsh-trigger]'));
    var openBtn = null;
    var openedByHoverAt = 0;
    var closeTimer = null;

    function panelOf(btn) { return document.getElementById(btn.getAttribute('aria-controls')); }

    function setPanel(btn, viaHover) {
      clearTimeout(closeTimer);
      if (btn === openBtn) return;
      if (openBtn) {
        openBtn.setAttribute('aria-expanded', 'false');
        panelOf(openBtn).classList.remove('is-open');
      }
      openBtn = btn || null;
      if (openBtn) {
        openBtn.setAttribute('aria-expanded', 'true');
        panelOf(openBtn).classList.add('is-open');
        openedByHoverAt = viaHover ? Date.now() : 0;
      }
    }

    triggers.forEach(function (btn) {
      on(btn, 'pointerenter', function (e) {
        if (e.pointerType !== 'mouse' || !DESKTOP.matches) return;
        setPanel(btn, true);
      });
      on(btn, 'click', function () {
        if (btn === openBtn) {
          // The hover that opened it is usually followed by a click; don't
          // treat that click as "close".
          if (Date.now() - openedByHoverAt < 600) return;
          setPanel(null);
        } else {
          setPanel(btn, false);
        }
      });
    });

    on(bar, 'pointerleave', function (e) {
      if (e.pointerType !== 'mouse' || !openBtn) return;
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () { setPanel(null); }, HOVER_CLOSE_MS);
    });
    on(bar, 'pointerenter', function () { clearTimeout(closeTimer); });

    var seasonal = root.querySelector('[data-wsh-seasonal]');
    if (seasonal) on(seasonal, 'pointerenter', function () { setPanel(null); });

    on(document, 'click', function (e) {
      if (openBtn && !bar.contains(e.target)) setPanel(null);
    });

    // Close when keyboard focus leaves the header entirely.
    on(bar, 'focusout', function (e) {
      if (openBtn && e.relatedTarget && !bar.contains(e.relatedTarget)) setPanel(null);
    });

    /* ---------- Desktop: keep the nav on one line ---------- */
    var nav = root.querySelector('.wsh-nav');
    function fitNav() {
      bar.classList.remove('is-compact');
      if (DESKTOP.matches && nav && nav.scrollWidth > nav.clientWidth + 1) bar.classList.add('is-compact');
    }
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(fitNav);
      ro.observe(bar);
      cleanups.push(function () { ro.disconnect(); });
    } else {
      on(window, 'resize', fitNav);
    }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitNav);
    fitNav();

    /* ---------- Mobile drawer ---------- */
    var burger = root.querySelector('[data-wsh-burger]');
    var drawer = root.querySelector('[data-wsh-drawer]');
    var accBtns = [].slice.call(root.querySelectorAll('[data-wsh-acc]'));
    var drawerOpen = false;

    function setDrawer(open) {
      drawerOpen = open;
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      if (open) {
        html.style.setProperty('--wsh-bar-bottom', Math.max(0, bar.getBoundingClientRect().bottom) + 'px');
        drawer.hidden = false;
        drawer.scrollTop = 0;
        html.classList.add('wsh-lock');
      } else {
        drawer.hidden = true;
        html.classList.remove('wsh-lock');
      }
    }

    function setAcc(btn) {
      accBtns.forEach(function (b) {
        var isOn = b === btn && b.getAttribute('aria-expanded') !== 'true';
        b.setAttribute('aria-expanded', isOn ? 'true' : 'false');
        document.getElementById(b.getAttribute('aria-controls')).hidden = !isOn;
      });
    }

    if (burger && drawer) {
      on(burger, 'click', function () { setDrawer(!drawerOpen); });
      accBtns.forEach(function (b) { on(b, 'click', function () { setAcc(b); }); });
    }

    on(document, 'keydown', function (e) {
      if (e.key !== 'Escape') return;
      if (openBtn) {
        var b = openBtn;
        setPanel(null);
        b.focus();
      } else if (drawerOpen) {
        setDrawer(false);
        burger.focus();
      }
    });

    function onBreakpoint() {
      setPanel(null);
      if (drawerOpen) setDrawer(false);
      syncOcc(true);
    }
    if (DESKTOP.addEventListener) on(DESKTOP, 'change', onBreakpoint);

    /* ---------- Occasion row: return on scroll up ---------- */
    var occ = root.querySelector('[data-wsh-occ]');
    var mode = root.dataset.occScroll || 'mobile';
    var pinned = false, shown = false, lastY = window.scrollY, travel = 0;

    function enabled() {
      if (!occ || drawerOpen) return false;
      return mode === 'all' || (mode === 'mobile' && !DESKTOP.matches);
    }
    function pin() {
      occ.style.height = occ.offsetHeight + 'px';
      html.style.setProperty('--wsh-bar-h', bar.offsetHeight + 'px');
      occ.classList.add('is-pinned');
      pinned = true;
    }
    function unpin() {
      occ.classList.remove('is-pinned', 'is-shown');
      occ.style.height = '';
      pinned = shown = false;
    }
    function show(yes) {
      shown = yes;
      if (yes) {
        // Let the hidden, pinned position paint first so the slide runs.
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { if (shown) occ.classList.add('is-shown'); });
        });
      } else {
        occ.classList.remove('is-shown');
      }
    }

    function syncOcc(reset) {
      if (!occ) return;
      if (reset || !enabled()) { if (pinned) unpin(); lastY = window.scrollY; travel = 0; return; }
      var y = window.scrollY;
      var dy = y - lastY;
      lastY = y;
      if (dy === 0) return;
      travel = (travel > 0) === (dy > 0) ? travel + dy : dy;

      var barH = bar.offsetHeight;
      var top = occ.getBoundingClientRect().top;
      var h = occ.offsetHeight;

      if (top >= barH - 1) { if (pinned) unpin(); return; } // natural spot is in view
      var fullyHidden = top + h <= barH;

      if (pinned && !shown && !fullyHidden) { unpin(); return; }
      if (travel < -12 && fullyHidden && !shown) {
        if (!pinned) pin();
        show(true);
      } else if (travel > 12 && shown && fullyHidden) {
        show(false);
      }
    }

    var ticking = false;
    on(window, 'scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () { ticking = false; syncOcc(false); });
    }, { passive: true });

    /* ---------- Theme editor: open what the merchant selects ---------- */
    on(document, 'shopify:block:select', function (e) {
      var el = e.target;
      if (!root.contains(el)) return;
      var panel = el.closest('[data-wsh-panel]');
      if (panel && DESKTOP.matches) {
        var btn = root.querySelector('[aria-controls="' + panel.id + '"]');
        if (btn) setPanel(btn, false);
      }
    });
    on(document, 'shopify:block:deselect', function () { setPanel(null); });

    current = function () {
      cleanups.forEach(function (fn) { fn(); });
      html.classList.remove('wsh-lock');
      current = null;
    };
  }

  /* ---------- Cart count ---------- */
  function refreshCartCount() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.style.display = cart.item_count > 0 ? '' : 'none';
        });
        document.querySelectorAll('[data-wsh-cart]').forEach(function (a) {
          a.setAttribute('aria-label', 'Cart, ' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items'));
        });
      })
      .catch(function () {});
  }
  ['cart:updated', 'cart:refresh', 'cart:change', 'cart:item-added'].forEach(function (ev) {
    document.addEventListener(ev, refreshCartCount);
  });
  window.addEventListener('pageshow', function (e) { if (e.persisted) refreshCartCount(); });

  function boot() { init(document.querySelector('[data-wsh]')); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target.querySelector('[data-wsh]'));
  });
  document.addEventListener('shopify:section:unload', function (e) {
    if (current && e.target.querySelector('[data-wsh]')) current();
  });
})();
